import type { PrintTemplate } from "@repo/types";
import { ARBRE_FIELDS, ARBRE_SECTIONS } from "./registry";
import type { PrintFieldDef, PrintSectionDef } from "./types";

/** Modèle livré avec le code : reproduit la fiche actuelle, sans aucune ligne en base. */
export function buildDefaultTemplate<TData>(
  inventoryType: PrintTemplate["inventoryType"],
  sections: PrintSectionDef[],
  fields: PrintFieldDef<TData>[],
): PrintTemplate {
  return {
    version: 1,
    inventoryType,
    header: {
      showLogo: true,
      showOrganisation: true,
      showSiret: true,
      showRecenseur: true,
    },
    sections: sections.map((section) => ({
      id: section.id,
      kind: "builtin" as const,
      visible: true,
      columns: section.defaultColumns,
      items: fields
        .filter((f) => f.section === section.id)
        .map((f) => ({
          field: f.key,
          visible: f.defaultVisible,
          col: f.defaultCol,
        })),
    })),
  };
}

export const DEFAULT_ARBRE_TEMPLATE: PrintTemplate = buildDefaultTemplate(
  "ARBRE",
  ARBRE_SECTIONS,
  ARBRE_FIELDS,
);
